import $ from 'jquery';

$(document).ready(function() {

    let searchFormMobile = $(".main-menubar .search-form-mobile").clone();
    let reportCTAMobile = $(".main-menubar .report-cta-desktop").clone();
    let talkCTAMobile = $(".main-menubar .talk-cta-desktop").clone();

    let desktopServicesMenuIcon = $(".main-menubar .services-tab .service-subnav-static-column .elementskit-info-box-icon img").clone();

    let mobileServicesMenuIcon = $(desktopServicesMenuIcon).addClass('mobile-menu-icon');

    let desktopTechnologiesMenuIcon = $(".main-menubar .technologies-tab .elementskit-info-box-icon img").clone();

    let mobileTechnologiesMenuIcon = $(desktopTechnologiesMenuIcon).addClass('mobile-menu-icon');

    let desktopGovernmentSolutionsMenuIcon = $(".main-menubar .government-solutions-tab .elementskit-info-box-icon img").clone();

    let mobileGovernmentSolutionsMenuIcon = $(desktopGovernmentSolutionsMenuIcon).addClass('mobile-menu-icon');

    let desktopCompanyMenuIcon = $(".main-menubar .company-tab .elementskit-info-box-icon img").clone();

    let mobileCompanyMenuIcon = $(desktopCompanyMenuIcon).addClass('mobile-menu-icon');

    let desktopResourcesMenuIcon = $(".main-menubar .resources-tab .elementskit-info-box-icon img").clone();

    let mobileResourcesMenuIcon = $(desktopResourcesMenuIcon).addClass('mobile-menu-icon');

    $(".main-menubar #menu-mega-menu.elementskit-navbar-nav").append('<li class="search-form-field-mobile"></li>');

    $(".main-menubar #menu-mega-menu.elementskit-navbar-nav").append('<li class="report-talk-cta-btns-mobile"></li>');

    $(".main-menubar #menu-mega-menu.elementskit-navbar-nav .search-form-field-mobile").append(searchFormMobile);

    $(".main-menubar #menu-mega-menu.elementskit-navbar-nav .report-talk-cta-btns-mobile").append(reportCTAMobile);

    $(".main-menubar #menu-mega-menu.elementskit-navbar-nav .report-talk-cta-btns-mobile").append(talkCTAMobile);

    //TODO: forloop
    $(".main-menubar #menu-mega-menu.elementskit-navbar-nav .services-megamenu .ekit-menu-nav-link").prepend(mobileServicesMenuIcon);

    $(".main-menubar #menu-mega-menu.elementskit-navbar-nav .technologies-megamenu .ekit-menu-nav-link").prepend(mobileTechnologiesMenuIcon);

    $(".main-menubar #menu-mega-menu.elementskit-navbar-nav .government-solutions-megamenu .ekit-menu-nav-link").prepend(mobileGovernmentSolutionsMenuIcon);

    $(".main-menubar #menu-mega-menu.elementskit-navbar-nav .company-megamenu .ekit-menu-nav-link").prepend(mobileCompanyMenuIcon);

    $(".main-menubar #menu-mega-menu.elementskit-navbar-nav .resources-megamenu .ekit-menu-nav-link").prepend(mobileResourcesMenuIcon);

    $(window).on("resize", function() {
        let serviceSubnavStaticColumnWidth = $('.main-menubar .service-subnav-static-column').width();

        $('.main-menubar .elementkit-tab-wraper.vertical nav.nav-tabs.elementkit-tab-nav').css('width', serviceSubnavStaticColumnWidth);

    });

    $('.main-menubar .elementkit-nav-link').attr('href', '#');

    $('.main-menubar .ekit-menu-nav-link').addClass('elementskit-submenu-indicator');

    $('.main-menubar .nav.nav-tabs.elementkit-tab-nav .elementkit-nav-item .elementkit-nav-link').each(function () {

        let mobileTabContent = $(this).siblings('.mobileTabContent');

        let tabIDTab = $(this).attr("id");
        let tabID = tabIDTab.slice(0, tabIDTab.lastIndexOf('-'));

        let tabContentID = '.main-menubar .tab-content.elementkit-tab-content #'+tabID;
        let tabContent = $(tabContentID).children('.animated.fadeIn').clone();

        mobileTabContent.append(tabContent);
    });

    $('.main-menubar .elementkit-nav-link').on("click", function() {

        $('.main-menubar .dynamic-service-box .ekit_global_links').attr('href', '#');

        let mainServiceTitle = $(this).find('.elementskit-tab-title').text();
        let subServiceBox = $(this).find('.elementskit-tab-sub-title').text();

        let subServiceText = subServiceBox.split('||');

        let subServiceSubText = subServiceText['0'];
        let subServiceURL = subServiceText['1'];

        let subServiceImageRemove = $('.main-menubar .dynamic-service-box .elementskit-info-box-icon img');

        let serviceIcon = $(this).find('.elementskit-tab-icon svg');

        $('.main-menubar .dynamic-service-box .elementskit-infobox').find('.elementskit-info-box-title').text(mainServiceTitle);
        $('.main-menubar .dynamic-service-box .elementskit-infobox').find('p').text(subServiceSubText);
        $('.main-menubar .dynamic-service-box .ekit_global_links').attr('href', subServiceURL);

        subServiceImageRemove.remove();

        $('.main-menubar .dynamic-service-box .elementskit-info-box-icon').empty().append(serviceIcon.clone());

        $(this).siblings('.mobileTabContent').toggleClass('open');

        $(".main-menubar .elementkit-nav-link").not($(this)).siblings('.mobileTabContent').removeClass('open');
        });
});